module.exports = __webpack_public_path__ + "static/media/calendarSidebar.5e03d4c4.svg";